import { createSelector, createStructuredSelector } from "reselect";
import { workareaSelector } from "features/workarea/selectors";
import { organizationSelector } from "features/organization/selectors";
import {
  userNameSelector,
  userEmailSelector,
  userPhotoSelector,
  allowedAccessSelector,
  userSelector
} from "../../features/auth/selectors";
// import userTokenIsValid from "./userTokenIsValid";

export const loggedInSelector = state => state.auth.get("isSignedIn"); // && userTokenIsValid(state.auth);
export const appDrawerOpenSelector = state => state.ui.getIn(["appDrawerOpen"]);
export const errorModalOpenSelector = state => state.ui.get("errorModalOpen");
export const errorMessageSelector = state => state.ui.get("errorModalBody");
export const renderDrawerSelector = createSelector([loggedInSelector], l => l);
export const modeSelector = state => state.ui.get("mode");
export const rebuildRunningSelector = state => state.ui.get("rebuildRunning");
export const lastRebuildDtSelector = state => state.ui.get("lastRebuildDt");

export const adminAccessSelector = createSelector(
  userSelector,
  user => user?.groups.includes("eims.admin@hakai.org") || false
);

export default createStructuredSelector({
  loggedIn: loggedInSelector,
  renderDrawer: renderDrawerSelector,
  appDrawerOpen: appDrawerOpenSelector,
  errorModalOpen: errorModalOpenSelector,
  errorMessage: errorMessageSelector,
  userPhoto: userPhotoSelector,
  username: userNameSelector,
  userEmail: userEmailSelector,
  workarea: workareaSelector,
  organization: organizationSelector,
  mode: modeSelector,
  rebuildRunning: rebuildRunningSelector,
  lastRebuildDt: lastRebuildDtSelector,
  allowedAccess: allowedAccessSelector,
  adminAccess: adminAccessSelector
});
